import API from './api';

const reportService = {
  // Get monthly attendance summary
  getMonthlyAttendanceSummary: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);
      if (filters.employee_id) params.append('employee_id', filters.employee_id);

      const response = await API.get(`/reports/monthly-attendance-summary?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching monthly attendance summary:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Export report data (placeholder for future enhancement)
  exportReport: async (reportType, format = 'csv', filters = {}) => {
    try {
      const params = new URLSearchParams();
      params.append('format', format);

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          params.append(key, value);
        }
      });

      const response = await API.get(`/reports/${reportType}/export?${params}`, {
        responseType: 'blob'
      });

      return response.data;
    } catch (error) {
      console.error('Error exporting report:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Export feature not available or network error');
    }
  },

  // Get monthly leave summary
  getMonthlyLeaveSummary: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);

      const response = await API.get(`/reports/monthly-leave-summary?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching monthly leave summary:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Get HR dashboard summary
  getHRDashboardSummary: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);

      const response = await API.get(`/reports/hr-dashboard-summary?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching HR dashboard summary:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Get calendar attendance data for visualization
  getCalendarAttendanceData: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);
      if (filters.employee_id) params.append('employee_id', filters.employee_id);

      const response = await API.get(`/reports/calendar-attendance-data?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching calendar attendance data:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Get time distribution summary for charts
  getTimeDistributionSummary: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);
      if (filters.employee_id) params.append('employee_id', filters.employee_id);

      const response = await API.get(`/reports/time-distribution-summary?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching time distribution summary:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Get daily timesheet report
  getDailyTimesheetReport: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);
      if (filters.employee_id) params.append('employee_id', filters.employee_id);

      const response = await API.get(`/reports/daily-timesheet-report?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching daily timesheet report:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Get anonymous feedback report
  getAnonymousFeedback: async () => {
    try {
      const response = await API.get('/reports/anonymous-feedback');
      return response.data;
    } catch (error) {
      console.error('Error fetching anonymous feedback:', error);
      if (error.response?.data) {
        throw error;
      }
      throw new Error('Network error or server unavailable');
    }
  },

  // Get project hours report
  getProjectHoursReport: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.year) params.append('year', filters.year);
      if (filters.month) params.append('month', filters.month);
      if (filters.project_id) params.append('project_id', filters.project_id);
      const response = await API.get(`/reports/project-hours-report?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project hours report:', error);
      if (error.response?.data) throw error;
      throw new Error('Network error or server unavailable');
    }
  }
};

export default reportService;